const APP_VERSION = import.meta.env.VITE_SHA || "VITE_SHA_NOT_SET";
export default APP_VERSION;
